import { useState } from "react";
import { NavLink, useNavigate, useLocation, Outlet } from "react-router-dom";
import { useAuth } from "../auth";
import { useClaims } from "../auth/useClaims";
import { Menu, LogOut, BarChart2, History, Monitor, Settings, Factory, Droplets, FlaskConical, Settings2, Wrench } from "lucide-react";

export default function Navbar() {
  const { logout } = useAuth();
  const { name } = useClaims();
  const nav = useNavigate();
  const location = useLocation();

  // Esconde o menu na rota de TV
  if (location.pathname.startsWith("/tv-mosaico")) {
    return <Outlet />;
  }

  const [open, setOpen] = useState(true);

  const doLogout = () => {
    logout();
    nav("/login");
  };

  const base =
    "flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors";
  const active = "bg-emerald-600 text-white";
  const inactive = "text-slate-700 hover:bg-slate-200";

  // 👤 Iniciais do nome
  const initials = name
    ? name
        .split(" ")
        .map((n: string) => n.charAt(0))
        .join("")
        .slice(0, 2)
        .toUpperCase()
    : "U";

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <aside
        className={`bg-white border-r border-slate-200 h-screen transition-all duration-300 flex flex-col ${
          open ? "w-56" : "w-16"
        }`}
      >
        {/* Topo com usuário */}
        <div className="flex items-center justify-between p-3 border-b">
          {open ? (
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center font-semibold">
                {initials}
              </div>
              <span className="text-sm font-medium text-slate-700">{name}</span>
            </div>
          ) : (
            <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center font-semibold">
              {initials}
            </div>
          )}

          <button
            onClick={() => setOpen(!open)}
            className="p-1 text-slate-600 hover:bg-slate-100 rounded"
          >
            <Menu size={20} />
          </button>
        </div>

        {/* Links */}
        <nav className="flex flex-col mt-4 gap-1">
          <NavLink
            to="/ResumoEnvasadora"
            className={({ isActive }) =>
              `${base} ${isActive ? active : inactive}`
            }
          >
            <BarChart2 size={18} />
            {open && "Envasadoras"}
          </NavLink>

          <NavLink
            to="/HistoricoProdutos"
            className={({ isActive }) =>
              `${base} ${isActive ? active : inactive}`
            }
          >
            <History size={18} />
            {open && "Histórico"}
          </NavLink>

          <NavLink
            to="/ConfigAnalise"
            className={({ isActive }) =>
              `${base} ${isActive ? active : inactive}`
            }
          >
            <Settings size={18} />
            {open && "Parametros"}
          </NavLink>

          <NavLink
            to="/Equipamentos"
            className={({ isActive }) =>
              `${base} ${isActive ? active : inactive}`
            }
          >
            <Settings2 size={18} />
            {open && "Equipamentos"}
          </NavLink>

          <NavLink
            to="/Motivos"
            className={({ isActive }) =>
              `${base} ${isActive ? active : inactive}`
            }
          >
            <Wrench size={18} />
            {open && "Motivos"}
          </NavLink>

          {/* TV abre em nova guia */}
          <a
            href="/tv-mosaico"
            target="_blank"
            rel="noopener noreferrer"
            className={`${base} ${inactive}`}
          >
            <Monitor size={18} />
            {open && "TV Mosaico"}
          </a>
        </nav>

        {/* Logout */}
        <div className="mt-auto p-3 border-t">
          <button
            onClick={doLogout}
            className="flex items-center gap-2 text-slate-600 hover:text-red-600 text-sm"
          >
            <LogOut size={16} />
            {open && "Sair"}
          </button>
        </div>
      </aside>

      {/* Conteúdo principal */}
      <main className="flex-1 overflow-y-auto bg-slate-50 p-4">
        <Outlet />
      </main>
    </div>
  );
}
